// @ts-nocheck
import { rowsPerPageInit } from "../../../utils/constants/paginationConstants";
import {
  FETCH_DASHBOARD_EVENTS_FAILURE,
  FETCH_DASHBOARD_EVENTS_REQUEST,
  FETCH_DASHBOARD_EVENTS_SUCCESS,
} from "../../constants/event/dashboard";

const initialState = {
  dashboard: [],
  searchString: "",
  searchBy: [],
  rowsPerPage: rowsPerPageInit,
  currentPage: 1,
  totalPages: null,
  totalEvents: null,
  isLoading: true,
  ucLoading: false,
  archiveLoading: false,
  filtersDate: null,
  // "Coordinators" column filter: { selected: [...], match: "any" | "all" } (null = none)
  coordinatorFilter: null,
  // "Show:" type chips (null = default: every submitted show, no drafts)
  eventTypes: null,
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action?.type) {
    case FETCH_DASHBOARD_EVENTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        searchString: action?.payload?.searchString,
        searchBy: action?.payload?.searchBy,
        rowsPerPage: action?.payload?.rowsPerPage,
        filtersDate: action?.payload?.filtersDate,
        coordinatorFilter: action?.payload?.coordinatorFilter ?? null,
        eventTypes: action?.payload?.eventTypes ?? null,
      };
    case FETCH_DASHBOARD_EVENTS_SUCCESS:
      return {
        ...state,
        dashboard: action?.payload?.data,
        totalPages: action?.payload?.pagination?.totalPages,
        currentPage: action?.payload?.pagination?.currentPage,
        isLoading: false,
      };
    case FETCH_DASHBOARD_EVENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
};

export { initialState };